/**
 * Redirect the search form to the correct URL on submit.
 */

const $searchForm = $('[data-search-form]');

const closeForm = () => {
  $('.backdrop').removeClass('active');
  // desktop
  $searchForm.removeClass('open');
  // mobile
  $('.site_header').removeClass('search_open filters_open nav_open');
  $('html').removeClass('modal-open');
};

$searchForm.on('submit', (e) => {
  e.preventDefault();
  const formData = $searchForm.serializeArray();
  const windowLocation = window.location;
  const currentURL = windowLocation.pathname + windowLocation.search + windowLocation.hash;
  const { value: title } = formData.find(({ name }) => name === 'search');
  const { value: location } = formData.find(({ name }) => name === 'location');
  const exploreLandedFrom = formData.find(({ name }) => name === 'landed_from');
  const { layout, initJobTitle, initLocation } = zr.page.model;

  let href = '/jobs-search?';
  let intsrc = '#intsrc=fe.job-results.header.dirp_form';
  if (windowLocation.pathname === '/jobs-explore') {
    intsrc = '#intsrc=fe.explore.header.search_form';
  }

  if (title && title !== '') {
    const titleFormatted = windowLocation.pathname === '/jobs-explore' ? title : title.replace(/\s+/g, '-');
    href += `search=${titleFormatted}&`;
  }

  if (location && location !== '') {
    const locationFormatted = location.replace(/\s+/g, '-').replace(',-', ',');
    href += `location=${locationFormatted}&`;
  }

  if (layout && layout !== '') {
    const layoutFormatted = layout.replace(/\s+/g, '-');
    href += `layout=${layoutFormatted}&`;
  }

  if (exploreLandedFrom) {
   if (exploreLandedFrom.value !== '' && title === '') {
      href += `landed_from=${exploreLandedFrom.value}`;
    }
  }

  if (href.endsWith('&')) {
    href = href.slice(0, -1);
  }

  // do not repeat identical search request, close the search form
  if (href === currentURL) {
    closeForm();
  } else {
    // register
    if (title !== initJobTitle || location !== initLocation) {
      if (title !== initJobTitle) {
        intsrc += '.search_change';
      }
      if (location !== initLocation) {
        intsrc += '.location_change';
      }
      href += intsrc;
    }

    windowLocation.href = href;
  }
});
